import { useCallback, useRef, type ReactNode } from 'react';
import type { RosterEntryFinalized } from '@discovr/types';
import { ConfirmedRollbackDialog, type RollbackDialogHandle } from './ConfirmedTab.rollbackDialog';

interface ConfirmedRollback {
  openRollback: (row: RosterEntryFinalized, opener?: HTMLElement | null) => void;
  dialogs: ReactNode;
}

// Same split as useConfirmedHold: dialog state lives in a child so opening it
// does not re-render the table and remount the menu trigger.
export function useConfirmedRollback(): ConfirmedRollback {
  const handle = useRef<RollbackDialogHandle>(null);
  const openRollback = useCallback<ConfirmedRollback['openRollback']>((row, opener) => handle.current?.openRollback(row, opener), []);
  return { openRollback, dialogs: <ConfirmedRollbackDialog ref={handle} /> };
}
